import { TypographySmall } from '@talentmesh/ui/components/typography';
import { useTeamMembersContext } from '../../Context/TeamMembersContext';
import ConfirmationDialog from './ConfirmationDialog';
import { useNotificationContext } from '@/Context/NotificationContext';
import UIStrings from '@/Utils/UIStrings';

const TeamMemberInvitationRevokeDialog = () => {
    const { revokeInvitation, activeDialog, closeDialog, selectedMember } = useTeamMembersContext();
    const { showFailToaster } = useNotificationContext();

    const handleClose = () => closeDialog();
    const handleConfirm = async () => {
        try {
            await revokeInvitation(selectedMember!);
            handleClose();
        } catch (e) {
            showFailToaster();
        }
    };

    return (
        <ConfirmationDialog
            open={activeDialog === 'RevokeInvitationConfirmation'}
            title={UIStrings.RevokeInvitation}
            actionButtonText={UIStrings.RevokeInvitation}
            onClose={handleClose}
            onConfirm={handleConfirm}
        >
            <TypographySmall>{`${UIStrings.AreYouSureYouWantToRevokeInvitationFor} `}</TypographySmall>
            <TypographySmall className="font-bold">{selectedMember?.email}</TypographySmall>
        </ConfirmationDialog>
    );
};

export default TeamMemberInvitationRevokeDialog;
